import {
  Grid,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import axios from 'axios';
import SchoolIcon from '@mui/icons-material/School'; // For AI Tutor
import CodeIcon from '@mui/icons-material/Code'; // For Assessment
import AssignmentIcon from '@mui/icons-material/Assignment'; // For Assignment
import VideoIcon from "../assets/svgImages/videoIcon.svg";
import TasklistIcon from "../assets/svgImages/taskListIcon.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReadingMaterial from "../assets/svgImages/readingMaterialIcon.svg";
import CustomDrawer from "./CustomDrawer";
import Assessment from "./Assessment";
import Readingmaterial from "./ReadingMaterial";
import { useParams, useNavigate } from "react-router-dom";
import AssessmentMentee from "./AssessmentMentee";
import { useSelector } from "react-redux";
import InfoToast from "components/Toaster/InfoToast";
import { AssessmentsManager, AssignmentsManager } from "./ModuleTasks";
import { moduleReportPath } from "./Submissions/submissionsApi";
import { AssessmentList, AssignmentList, TasksChip } from "./ModuleTasks/StudentTasks";
import StudyMaterialsPanel from "./StudyMaterials/StudyMaterialsPanel";
import SessionTracking from "./Sessions/SessionTracking";
function ConceptBuildingData({ course, assessmentStats, tasks }) {
  const [expanded, setIsExpanded] = useState(false);
  const [isSessionTrackingOpen, setIsSessionTrackingOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isReadingMaterialDrawerOpen, setIsReadingMaterialDrawerOpen] =
    useState(false);
  const { id } = useParams(); // Extract the ID from the URL
  const navigate = useNavigate();
  const userProfile = useSelector((state) => state.userProfile);
  const userRole = userProfile?.data?.role;
  const [showInfoToast, setShowInfoToast] = useState(false);
  const [infoMessage, setInfoMessage] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [isContentLoading, setIsContentLoading] = useState(false);
  const [isManageQuestionsOpen, setIsManageQuestionsOpen] = useState(false);
  const [isViewAssignmentsOpen, setIsViewAssignmentsOpen] = useState(false);

  // Mentors manage the module's assessments and assignments. A cohort
  // student's module is the batch's: manage it there, for the whole batch.
  const taskKind = course?.is_cohort && course?.cohort_module_id ? "template" : "topic";
  const taskModuleId = taskKind === "template" ? course.cohort_module_id : course?.id || course?.topic_id;

  const handleContentView = () => {
    const topicId = course?.id || course?.topic_id;
    const topicTemplateId = course?.topic_template_id;

    // Pass topic_template_id for cohort, topic_id for 1:1
    if (topicTemplateId) {
      // Cohort mode - use template chapters API
      navigate(`/dashboard/workspace/${id}/reading-material`, {
        state: { topic_template_id: topicTemplateId }
      });
    } else if (topicId) {
      // 1:1 mode - use course topic chapters API
      navigate(`/dashboard/workspace/${id}/reading-material`, {
        state: { topic_id: topicId }
      });
    } else {
      setInfoMessage('No reading material available');
      setShowInfoToast(true);
    }
  };

  const handleAITutor = () => {
    // Navigate to AI Tutor page for this topic
    const topicId = course?.id || course?.topic_id;
    if (topicId) {
      navigate(`/dashboard/workspace/${id}/ai-tutor/${topicId}`);
    } else {
      setInfoMessage('Unable to access AI Tutor');
      setShowInfoToast(true);
    }
  };

  const handleAssessment = () => {
    // Navigate to Assessment Workspace for this topic
    const topicId = course?.id || course?.topic_id;
    if (topicId) {
      navigate(`/dashboard/workspace/${id}/assessment/${topicId}`);
    } else {
      setInfoMessage('Unable to access Assessment');
      setShowInfoToast(true);
    }
  };


  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };


  const toggleReadingMaterialDrawer = () => {
    setIsReadingMaterialDrawerOpen(!isReadingMaterialDrawerOpen);
  };

  const toggleAccordion = () => {
    setIsExpanded(!expanded);
  };

  const toggleSessionTracking = () => {
    setIsSessionTrackingOpen(!isSessionTrackingOpen);
  };


  const handleOpenSubmissions = () => {
    const topicId = course?.id || course?.topic_id;
    if (topicId && id) {
      navigate(`/dashboard/workspace/${id}/assessment/${topicId}/review/${id}`);
    }
  };


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Accordion
            TransitionProps={{ unmountOnExit: true }}
            expanded={isSessionTrackingOpen}
            onChange={() => toggleSessionTracking()}
            sx={{
              ".MuiAccordionSummary-content": {
                margin: "0px",
              },
              padding: "8px",
              borderRadius: "10px",
              boxShadow: "none",
              padding: "0px",
            }}
            p={1}
          >
            <AccordionSummary
              sx={{
                backgroundColor: "#E5F1F6",
                width: "100%",
                display: "flex",
                alignItems: "center",
                py: 0,
                px: 1,
                minHeight: "37px !important",
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <img
                src={VideoIcon}
                alt="Task List"
                style={{ marginRight: 8 }}
              />
              <Typography
                sx={{
                  color: "#202124",
                  fontSize: "14px",
                  flex: 1,
                  fontFamily: "Be Vietnam Pro",
                  cursor: "pointer",
                }}
              >
                Session Tracking
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
  {course?.cohort_module_id ? (
    // Cohorts: every class of the module, with protected recordings.
    <SessionTracking moduleId={course.cohort_module_id} basePath={`/dashboard/workspace/${id}/sessions`} />
  ) : (
  // 1:1: this card's classes, with the same protected player as a cohort's.
  <SessionTracking moduleId={course?.id || course?.topic_id} kind="topic" basePath={`/dashboard/workspace/${id}/sessions`} />
  )}
</AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: "#E5F1F6",
              width: "100%",
              display: "flex",
              p: 1,
              cursor: "pointer",
              transition: "background-color 0.3s",
              "&:hover": {
                backgroundColor: "#d0e5ed",
              },
            }}
            onClick={handleContentView}
          >
            <img src={ReadingMaterial} alt="Video" style={{ marginRight: 8 }} />
            <Typography
              sx={{
                color: "#202124",
                fontSize: "14px",
                fontFamily: "Be Vietnam Pro",
                cursor: "pointer",
              }}
            >
              Reading material / FlowState Content
            </Typography>
          </Box>
        </Grid>

        {/* Supplements. A cohort card shows the batch module's once the mentor shares
            something. A 1:1 card has its own, this student's alone: the mentor always
            sees the row (to add to it), the student once there is something in it. */}
        {course?.is_cohort
          ? course?.study_materials_module_id && course?.study_materials_count > 0 && (
            <Grid item xs={12}>
              <StudyMaterialsPanel
                moduleId={course.study_materials_module_id}
                moduleName={course.name}
                initialCount={course.study_materials_count}
              />
            </Grid>
          )
          : (userRole === "mentor" || course?.study_materials_count > 0) && (
            <Grid item xs={12}>
              <StudyMaterialsPanel
                moduleId={course?.id || course?.topic_id}
                moduleName={course?.name}
                kind="topic"
                canEdit={userRole === "mentor"}
                initialCount={course?.study_materials_count || 0}
                label="Supplements (this student only)"
              />
            </Grid>
          )}

        {/* AI Tutor: 1:1 only, cohorts don't use it */}
        {!course?.is_cohort && (
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: "#E5F1F6",
              width: "100%",
              display: "flex",
              alignItems: "center",
              p: 1,
              cursor: "pointer",
              transition: "background-color 0.3s",
              "&:hover": {
                backgroundColor: "#d0e5ed",
              },
            }}
            onClick={handleAITutor}
          >
            <SchoolIcon sx={{ color: "#0172A6", fontSize: 20, marginRight: "8px" }} />
            <Typography
              sx={{
                color: "#202124",
                fontSize: "14px",
                fontFamily: "Be Vietnam Pro",
                cursor: "pointer",
              }}
            >
              AI Tutor
            </Typography>
          </Box>
        </Grid>
        )}

        <Grid item xs={12}>
          <Accordion
            expanded={expanded}
            onChange={() => toggleAccordion()}
            sx={{
              ".MuiAccordionSummary-content": {
                margin: "0px",
              },
              padding: "8px",
              borderRadius: "10px",
              boxShadow: "none",
              padding: "0px",
            }}
            p={1}
          >
            <AccordionSummary
              sx={{
                backgroundColor: "#E5F1F6",
                width: "100%",
                display: "flex",
                alignItems: "center",
                py: 0,
                px: 1,
                minHeight: "37px !important",
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <img
                src={TasklistIcon}
                alt="Task List"
                style={{ marginRight: 8 }}
              />
              <Typography
                sx={{
                  color: "#202124",
                  fontSize: "14px",
                  flex: 1,
                  fontFamily: "Be Vietnam Pro",
                  cursor: "pointer",
                }}
              >
                Task Lists
              </Typography>
              {userRole !== "mentor" && (
                <Box sx={{ mr: 1 }} onClick={(e) => e.stopPropagation()}><TasksChip tasks={tasks} /></Box>
              )}
            </AccordionSummary>
            <AccordionDetails>
              <Box
                sx={{
                  backgroundColor: userRole === "mentor" ? "#e3f0f9" : "#E8EDF0",
                  border: userRole === "mentor" ? "1px solid #9fcdea" : "none",
                  ml: 4,
                  p: userRole === "mentor" ? 1.5 : 1,
                  width: "98%",
                  my: 1,
                  fontSize: "15px",
                  fontFamily: "Be Vietnam Pro",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: userRole === "mentor" ? "8px" : "0px",
                  flexWrap: "wrap",
                  "&:hover": {
                    backgroundColor: userRole === "mentor" ? "#d9ebf7" : "#dce3e8",
                  },
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "8px", flex: 1 }}
                  onClick={() => {
                    const topicId = course?.id || course?.topic_id;
                    if (topicId) {
                      navigate(`/dashboard/workspace/${id}/assignments/${topicId}`);
                    }
                  }}
                >
                  <AssignmentIcon sx={{ fontSize: 18, color: "#0172A6" }} />
                  <Typography sx={{ fontWeight: userRole === "mentor" ? 600 : 400, fontSize: "15px" }}>
                    Assignment
                  </Typography>
                </Box>

                {userRole === "mentor" && (
                  <>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsViewAssignmentsOpen(true);
                    }}
                    sx={{
                      fontSize: "12px",
                      textTransform: "none",
                      borderColor: "#9fcdea",
                      color: "#0f6ca8",
                      background: "#fff",
                      "&:hover": {
                        borderColor: "#0f6ca8",
                        background: "#f0f7fc",
                      },
                    }}
                  >
                    Manage assignments
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(moduleReportPath(taskKind, taskModuleId, "assignments"));
                    }}
                    sx={{
                      fontSize: "12px",
                      textTransform: "none",
                      borderColor: "#9fcdea",
                      color: "#0f6ca8",
                      background: "#fff",
                      "&:hover": {
                        borderColor: "#0f6ca8",
                        background: "#f0f7fc",
                      },
                    }}
                  >
                    Submissions
                  </Button>
                  </>
                )}
              </Box>
              {/* A student's assignments, each its own row */}
              {userRole !== "mentor" && tasks && (
                <AssignmentList
                  assignments={tasks.assignments}
                  onOpen={() => navigate(`/dashboard/workspace/${id}/assignments/${course?.id || course?.topic_id}`)}
                />
              )}
              {/* Assessment Row - Enhanced for Mentor View */}
              <Box
                sx={{
                  backgroundColor: userRole === "mentor" ? "#e3f0f9" : "#E8EDF0",
                  border: userRole === "mentor" ? "1px solid #9fcdea" : "none",
                  ml: 4,
                  p: userRole === "mentor" ? 1.5 : 1,
                  width: "98%",
                  fontSize: "15px",
                  fontFamily: "Be Vietnam Pro",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: userRole === "mentor" ? "8px" : "0px",
                  flexWrap: "wrap",
                  "&:hover": {
                    backgroundColor: userRole === "mentor" ? "#d9ebf7" : "#dce3e8",
                  },
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "8px", flex: 1 }}
                  onClick={handleAssessment}
                >
                  <CodeIcon sx={{ fontSize: 18, color: "#0172A6" }} />
                  <Typography sx={{ fontWeight: userRole === "mentor" ? 600 : 400, fontSize: "15px" }}>
                    Assessment
                  </Typography>
                </Box>

                {/* Mentor-only buttons */}
                {userRole === "mentor" && (
                  <>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsManageQuestionsOpen(true);
                      }}
                      sx={{
                        fontSize: "12px",
                        textTransform: "none",
                        borderColor: "#9fcdea",
                        color: "#0f6ca8",
                        background: "#fff",
                        "&:hover": {
                          borderColor: "#0f6ca8",
                          background: "#f0f7fc",
                        },
                      }}
                    >
                      Manage assessments
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(moduleReportPath(taskKind, taskModuleId, "assessments"));
                      }}
                      sx={{
                      fontSize: "12px",
                      textTransform: "none",
                      borderColor: "#9fcdea",
                      color: "#0f6ca8",
                      background: "#fff",
                      "&:hover": {
                        borderColor: "#0f6ca8",
                        background: "#f0f7fc",
                      },
                    }}
                    >
                      Results
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenSubmissions();
                      }}
                      sx={{
                        fontSize: "12px",
                        textTransform: "none",
                        background: "#0f6ca8",
                        "&:hover": {
                          background: "#0b5183",
                        },
                      }}
                    >
                      Open submissions →
                    </Button>
                  </>
                )}
              </Box>
              {/* A student's assessments, each its own row, opening just that assessment */}
              {userRole !== "mentor" && tasks && (
                <Box sx={{ mt: 1 }}>
                  <AssessmentList
                    assessments={tasks.assessments}
                    onOpen={(a) => navigate(
                      `/dashboard/workspace/${id}/assessment/${course?.id || course?.topic_id}?assessment=${a.id ?? "other"}`
                    )}
                  />
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
        </Grid>
        {/* <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: "#E5F1F6",
              width: "100%",
              display: "flex",
              p: 1,
            }}
          >
            <img src={FolderIcon} alt="Folder" style={{ marginRight: 8 }} />
            <Typography sx={{ color: "#202124", fontSize: "14px" }}>
              Mentor's repository for mentee
            </Typography>
          </Box>
        </Grid> */}
      </Grid>
      <CustomDrawer
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title={"Assessment"}
        isBack={userRole === "mentee"}
      >
        <Typography variant="h6" marginTop={"60px"}>
          {userRole === "mentor" ? (
            <Assessment
              course={course}
              onClose={() => setIsDrawerOpen(false)}
            />
          ) : userRole === "mentee" ? (
            <AssessmentMentee />
          ) : (
            <Typography
              fontSize={"16px"}
              fontWeight={500}
              variant="h6"
              fontFamily={"Be Vietnam Pro"}
            >
              No Assessment available.
            </Typography>
          )}
        </Typography>
      </CustomDrawer>
      <CustomDrawer
        open={isReadingMaterialDrawerOpen}
        onClose={() => setIsReadingMaterialDrawerOpen(false)}
        title={"Reading Material"}
      >
        <Typography variant="h6" marginTop={"60px"}>
          {isContentLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
              <CircularProgress />
            </Box>
          ) : htmlContent ? (
            <Box sx={{ p: 2 }}>
              <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </Box>
          ) : (
            <Readingmaterial course={course} />
          )}
        </Typography>
      </CustomDrawer>
      {showInfoToast && (
        <InfoToast
          message={infoMessage}
          onClose={() => setShowInfoToast(false)}
        />
      )}
      <AssessmentsManager
        open={userRole === "mentor" && isManageQuestionsOpen}
        onClose={() => setIsManageQuestionsOpen(false)}
        kind={taskKind}
        moduleId={taskModuleId}
        moduleName={course?.name}
      />
      <AssignmentsManager
        open={userRole === "mentor" && isViewAssignmentsOpen}
        onClose={() => setIsViewAssignmentsOpen(false)}
        kind={taskKind}
        moduleId={taskModuleId}
        moduleName={course?.name}
      />
      {/* <Grid container>
        <Grid item xs={12} sm={12}>
          <Drawer
            anchor="right"
            open={isDrawerOpen}
            onClose={() => setIsDrawerOpen(false)}
            sx={{
              ".MuiPaper-root": {
                width: "90% !important",
              },
            }}
          >
            <Box p={2}>
              <Box display="flex" justifyContent="flex-end">
                <Box width={"100%"} display={'flex'} position={'absolute'} top={0} backgroundColor="#0172A6" right={0}>
                  <Box width={"100%"} height={'64px'}></Box>
                  <IconButton onClick={() => setIsDrawerOpen(false)}>
                    <CloseIcon sx={{color: 'white'}}/>
                  </IconButton>
                </Box>
              </Box>
              <Typography variant="h6">This is the Drawer content</Typography>
            </Box>
          </Drawer>
        </Grid>
      </Grid> */}
    </>
  );
}

export default ConceptBuildingData;
